<template>
    <div class="list-bg">
        <!--  :class="{selected: itemObj.hotspot_mark.name === selectId}" -->
        <div class="content" :class="{selected: itemObj.hotspot_mark.name === selectId}">
            <span class="list-name">{{itemObj.title}}</span>

            <options :option-list="optionList" @onClick="handleMenuClick">
                {{$t('edit.ruler.operation')}}<a-icon type="down" />
            </options>
        </div>
    </div>
</template>

<script>
    import Options from "../Options";
    export default {
        name: "rulerList",
        props:{
            itemObj: {
                required: true,
                type: Object,
            },
            selectId:{
                type:String,
                defalut:''
            }
        },
        components:{
            Options
        },
        data(){
            return{
                optionList:[
                    {title: this.$t("edit.ruler.edit"),type: 'edit'},
                    {title: this.$t("edit.ruler.rename"),type: 'rename'},
                    {title: this.$t("edit.ruler.delete"),type: 'delete'},
                ]
            }
        },
        methods: {
            handleMenuClick(type) {
                if (type === "edit") {
                    this.$emit("editItem", this.itemObj);
                } else if (type === "rename") {
                    this.$emit("renameItem", this.itemObj);
                } else if (type === "delete") {
                    this.$emit("deleteItem", this.itemObj);
                }
            },
        },
    }
</script>

<style scoped>

</style>
